const fr = {
	Credentials: "Diplômes",
	Logout: "Déconnexion",
	"My Credentials": "Mes diplômes ",
	"Issue Date": "Issue Date",
	By: "Par",
	View: "Visionner",
	Verify: "Vérifier",
	purchase_for: "Acheter pour",
	"Terms of Service": "Conditions d’utilisation",
	"Privacy & Data Protection": "Protection des données privées",
	"Customer Support": "Assistance client",
	"Help Center": "Centre d’aide",
	"Verify Certificate": "Vérifier le certificat",
	"View Certificate": "Visionner le certificat",
	Inbox: "Boîte de réception",
	//to do
	"Open Issuers App": "Emittenten-App",
	Name: "Name",
	"You are purchasing": "Sie kaufen",
	"Payment info": "Zahlungsinformationen",
	Email: "Email",
};
export default fr;
